// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Children, cloneElement } from '../../utils';
import { wrapFunction } from '../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import MenuItem from './MenuItem';
import MenuSelectableItem from './MenuSelectableItem';

import '../../helpers/base.less';
import './Menu.less';

const hasIconItem = children => {
    let result = false;
    Children.forEach(children, child => {
        if (
            (child.type === MenuItem && child.props.icon) ||
            child.type === MenuSelectableItem
        ) {
            result = true;
        }
    });

    return result;
};

/**
 * `Menu` component displays grouped controls for navigating the UI, performing actions on objects, or showing
 * options for [Lists](#!/List) (for example, sorting and filtering settings). `Menu` is most typically used in a
 * [Dropdown](#!/Dropdown). `Menu` consists of several [Menu Items](#!/MenuItem) or [Selectable Menu
 * Items](#!/MenuSelectableItem).
 */
const Menu = ({ baseClassName, className, children, onItemClick, ...props }) => (
    <ul
        className={classNames(baseClassName, className, {
            [`${baseClassName}--icons`]: hasIconItem(children),
        })}
        {...props}
    >
        {Children.map(children, (child, index) => {
            if (onItemClick && child && (child.type === MenuItem || child.type === MenuSelectableItem)) {
                return cloneElement(child, {
                    onClick: wrapFunction(child.props.onClick, onItemClick.bind(null, child, index)),
                });
            }

            return child;
        })}
    </ul>
);

Menu.propTypes = {
    /**
     * Triggered when menu item was clicked.
     */
    onItemClick: PropTypes.func,
    /**
     * Content of the `Menu`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Menu.defaultProps = {
    onItemClick: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}menu`,
};

export default Menu;



// WEBPACK FOOTER //
// ./components/Menu/Menu.js